import React from 'react'
import { connect } from 'react-redux'
import { fetchCustomers } from '../../actions/customer-actions'
import { Grid, Row, Table } from 'react-bootstrap'
import qs from 'qs'

import SearchBar from '../../components/SearchBar'
import Breadcrumbs from '../../components/Breadcrumbs'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../messages'

class CustomerOverview extends React.Component {
  constructor() {
    super()
    this.state = { query: undefined }
  }

  componentDidMount() {
    if (this.props.location.search) {
      let params = qs.parse(this.props.location.search.substring(1))
      this.setState({ query: params.query })
      this.props.fetchCustomers(params.query)
    }
  }

  search(query) {
    this.props.fetchCustomers(query)
  }

  render() {
    const { searchResults } = this.props

    return (
      <Grid>
        <Breadcrumbs />
        <SearchBar
          value={this.state.query || searchResults.query}
          action="/klanten"
          placeholder="Zoek klant"
          callback={(query) => this.search(query)}
        />

        <Row>
          <div className="tablescontainer">
            {searchResults.length > 0 ? (
              <Table striped>
                <thead>
                  <tr>
                    <th>Naam</th>
                    <th>Werkmaatschappij</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResults.map((customer, index) => (
                    <tr key={index} onClick={() => this.props.history.push(`/klanten/${customer.id}`)}>
                      <td>{customer.name}</td>
                      <td>{customer.identityProvider.subsidiary.name}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <SearchInfo />
            )}
          </div>
        </Row>
      </Grid>
    )
  }
}

let SearchInfo = () => (
  <div>
    <p>{SEARCH_INSTRUCTIONS}</p>
    <p>Zoek op:</p>
    <ul>
      <li>Klantnaam</li>
      <li>
        Product
        <ul>
          <li>Naam</li>
          <li>EAN</li>
        </ul>
      </li>
    </ul>
    <p>{NO_SEARCH_RESULTS}</p>
  </div>
)

export default connect(
  (state) => {
    return { searchResults: state.customers.searchResults }
  },
  {
    fetchCustomers,
  }
)(CustomerOverview)
